export default "__VITE_ASSET__9fad236e__"